import { render, staticRenderFns } from "./CardPosition.vue?vue&type=template&id=1bb56b44&scoped=true"
import script from "./CardPosition.vue?vue&type=script&lang=js"
export * from "./CardPosition.vue?vue&type=script&lang=js"
import style0 from "./CardPosition.vue?vue&type=style&index=0&id=1bb56b44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb56b44",
  null
  
)

export default component.exports